import { Injectable } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';

@Injectable()
export class MessageProvider {

    private loadingCmp: any;
    private toast: any;

    constructor(private loadingCtrl: LoadingController, private toastCtrl: ToastController) {
    }

    async presentLoading(message?: string) {

        if (this.loadingCmp) {
            return;
        }

        if (message == null) {
            message = '';
        }

        this.loadingCmp = await this.loadingCtrl.create({
            spinner: 'crescent',
            message,
            cssClass: 'loading-nativo',
        });

        return await this.loadingCmp.present();
    }

    async dismissLoading(): Promise<any> {

        return new Promise((resolve) => {
            if (this.loadingCmp) {
                this.loadingCmp.dismiss().then(() => {
                    this.loadingCmp = null;
                    resolve(undefined);
                });
            } else {
                resolve(undefined);
            }
        });
    }

    async showToast(mensagem: string | Error, duration = 3000) {

        this.fecharToast();

        if (!mensagem) {
            return;
        }

        let textoMensagem: string;
        if (mensagem instanceof Error) {
            textoMensagem = mensagem.message;
        } else {
            textoMensagem = mensagem;
        }

        this.toast = await this.toastCtrl.create({
            message: textoMensagem,
            duration,
            position: 'top',
            buttons: [
                {
                    text: 'X',
                    role: 'Dismiss',
                }
            ]
        });
        this.toast.present();
    }

    private async fecharToast() {
        if (this.toast) {
            await this.toast.dismiss();
            this.toast = null;
        }
    }

}
